export default {
  // getDocuments: (state) => state.documents,
  // getDocument: (state) => (id) => {
  //   return state.documents.find(document => document.id === parseInt(id))
  // },
  // getEmptyDocument: (state) => JSON.parse(JSON.stringify(state.emptyDocument)),
}